import * as React from 'react'
import * as UI from '@brewlogix/blx-ui'

import ActivitiesLocationSlug from '../ActivitiesLocationSlug'
import AmenitiesList from './AmenitiesList'
import { Location } from 'src/types/schema/graphql'
import classNames from 'classnames'
import { useStickyNav } from '../../state/useStickyNav'

interface IAmenitiesAndMore {
    location: Location
}

const AmenitiesAndMore: React.FC<IAmenitiesAndMore> = ({ location }) => {
    const { space } = useStickyNav()
    return (
        <div className={classNames('mt-20 space-y-6', space)} id='amenities'>
            <UI.Heading
                text='Amenities and more'
                size='h4'
                type='h2'
                customClasses='text-xl lg:text-2xl text-gray-500 font-extrabold'
            />

            <AmenitiesList location={location} />
            <ActivitiesLocationSlug location={location} />
        </div>
    )
}

export default AmenitiesAndMore
